import React from "react";
import { useFormContext } from "react-hook-form";

const useValidateExplicitField = () => {
  const { trigger } = useFormContext();
  const validateField = async (field: string) => {
    await trigger(field, { shouldFocus: true });
  };
  return {
    validateField
  };
};

export default useValidateExplicitField;
